export const CLEANING_STATUS = {
  COMPLETED: "COMPLETED",
  ERROR: "ERROR",
  CANCEL: "CANCEL",
  PAUSED: "PAUSED",
  UNKNOWN: "UNKNOWN",
} as const;

export type CleaningStatus = (typeof CLEANING_STATUS)[keyof typeof CLEANING_STATUS]